import { SaveAndCancel } from "@dealer-center/core-custom-components";

interface ImportModalSaveInterface {
  setShowImportModal: (value: boolean) => void;
  selectedConfig: string;
  configSaved: () => void;
  selectedConfigDataLoading: boolean;
}
export const ImportModalSave = ({
  setShowImportModal,
  selectedConfig,
  selectedConfigDataLoading,
  configSaved
}: ImportModalSaveInterface) => {
  return (
    <SaveAndCancel
      analyticsEventName="Website Inventory Config Import Configuration"
      isDisabled={{
        save: !selectedConfig || selectedConfigDataLoading
      }}
      saveButtonText="Import Changes"
      onCancel={() => setShowImportModal(false)}
      onSave={() => {
        configSaved();
        setShowImportModal(false);
      }}
    />
  );
};
